export default __webpack_public_path__ + "1be0bb3aa5fe6824bbdd3cd0b99472f1.png";